import { useOutletContext } from "react-router-dom";
import { add, subtract, toSnapshot } from "dinero.js";
import { cents, Money } from "../Data/Money";

interface ParkerBalanceContext {
    balance:    Money;
    setBalance: ( b: Money ) => void;
}

/**
 * Wraps the parker outlet context balance and provides helpers so every
 * child page applies credits / order adjustments the same way.
 */
export function useParkerBalance() {
    const { balance, setBalance } = useOutletContext<ParkerBalanceContext>();

    /** Call after a credit or payment is applied (reduces balance). */
    function applyCredit( payment: { amount: Money } ) {
        const creditCents = toSnapshot( payment.amount ).amount;
        setBalance( cents( toSnapshot( balance ).amount - creditCents ) );
    }

    /**
     * Call after an order debt adjustment.
     * @param delta  dinero Money representing the change (positive = more owed, negative = less owed).
     */
    function applyOrderAdjust( delta: Money ) {
        setBalance( add( balance, delta ) );
    }

    return { balance, setBalance, applyCredit, applyOrderAdjust };
}
